export default {
	type: 'object',
	properties: {
		input: {
			type: 'string',
		},
		after: {
			type: ['string', 'null'],
		},
		first: {
			type: 'integer',
		},
	},
	required: [],
	additionalProperties: false,
}
